import {
    AutocompleteInput,
    SelectArrayInput,
    Filter,
    ReferenceInput,
    SelectInput,
    TextInput,
    DateInput
} from 'react-admin';


const TransactionFilter = (props: any) => (
    <Filter {...props}>

        <ReferenceInput label="User" source="user" reference="user" allowEmpty alwaysOn>
            <AutocompleteInput optionText="profile.nickname"
                filterToQuery={txt => ({ profile: { nickname: txt } })}
                size='small'
            />
        </ReferenceInput>
        <TextInput label="id" source="id" alwaysOn />
        <TextInput label="Ref" source="refId" alwaysOn />
        <ReferenceInput label="product" source="product" reference="product" allowEmpty>
            <AutocompleteInput optionText="title"
                size='small'
            />
        </ReferenceInput>
        <SelectInput source="currency" label="currency" choices={[
            { id: 'USD', name: 'USD' },
            { id: 'EUR', name: 'EUR' },
            { id: 'GBP', name: 'GBP' }
        ]} />
        <SelectArrayInput label="status" source="status" choices={[
            { id: 'init', name: 'init' },
            { id: 'complete', name: 'complete' },
            { id: 'failed', name: 'failed' },
            { id: 'pending', name: 'pending' }
        ]}>
        </SelectArrayInput>
        <SelectInput label="type" source="type" choices={[
            { id: 'payment', name: 'payment' },
            { id: 'chargeback', name: 'chargeback' },
            { id: 'cancelation', name: 'cancelation' },
            { id: 'expired', name: 'expired' }
        ]} />
        <SelectInput label="is test" source="isTest" fullWidth choices={[
            { id: 'true', name: "Yes" },
            { id: 'false', name: "No" },
        ]} />
        <DateInput source="updatedAt" />
        <SelectInput label="provider" source="provider" choices={[
            { id: 'myppk', name: 'MyPapik' },
            { id: 'walletto', name: 'Walletto' },
            { id: 'maxpay', name: 'MaxPay' },
            { id: 'binance', name: 'Binance' }
        ]} />

    </Filter>
);

export default TransactionFilter;